import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/** @jsx jsx */
import { css } from '@emotion/react';
import { N70, N20, N40, B100 } from '@atlaskit/theme/colors';
import { borderRadius } from '@atlaskit/theme/constants';
export var DISABLED_BUTTON_COLOR = "".concat("var(--ds-text-disabled, ".concat(N70, ")"), " !important");
export var triggerStyle = function triggerStyle(_ref) {
  var _ref$miniMode = _ref.miniMode,
    miniMode = _ref$miniMode === void 0 ? false : _ref$miniMode,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  return css(_objectSpread(_objectSpread(_objectSpread({
    minWidth: '32px',
    height: '24px',
    padding: 0,
    border: "1px solid ".concat("var(--ds-border, ".concat(N40, ")")),
    borderRadius: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    lineHeight: '16px'
  }, miniMode && {
    minWidth: '24px',
    padding: '4px',
    border: 'none',
    borderRadius: "".concat(borderRadius(), "px")
  }), disabled && {
    color: DISABLED_BUTTON_COLOR,
    cursor: 'not-allowed'
  }), {}, {
    '&:hover': {
      background: "".concat("var(--ds-background-neutral-subtle-hovered, ".concat(N20, ")"))
    },
    '&:focus': {
      boxShadow: "0 0 0 2px ".concat("var(--ds-border-focused, ".concat(B100, ")")),
      transitionDuration: '0s, 0.2s',
      outline: 'none'
    }
  }));
};